import React from 'react';
import PageHero from '../components/common/PageHero';
import Offerings from '../components/home/Offerings';
import Export from '../components/home/Export';
import ShipStoresSupply from '../components/home/ShipStoresSupply';

const OurServices = () => {
  return (
    <div>
      <PageHero
        title="Our Services"
        subtitle="Maritime supply, export programs, and end-to-end logistics built for reliability and compliance."
      />
      <Offerings />
      <Export />
      <ShipStoresSupply />
    </div>
  );
};

export default OurServices;